import {AlertType} from "../../interfaces/IAlert"; import {AlertType} from
"../../interfaces/IAlert"; import {PaymentDataType} from
"../../enums/PaymentDataType";
<template>
  <v-card class="new-card-modal">
    <v-card-text>
      <template v-if="!initialized">
        <v-skeleton-loader type="paragraph" />
      </template>
      <v-row v-else class="flex-md-nowrap">
        <v-col cols="12" class="order-2 px-8">
          <v-form @submit.prevent v-model="formValid">
            <card-widget
              :fields="formFields"
              :labels="cardData"
              :current-focus="currentFocus"
              class="mb-4"
            />
            <v-row>
              <v-col cols="12" sm="6" class="pb-0">
                <v-select
                  label="Tipo de documento"
                  return-object
                  filled
                  dense
                  item-text="name"
                  :rules="$rule('required')"
                  :items="idTypes"
                  v-model="idType"
                />
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  filled
                  dense
                  label="Número de documento"
                  :rules="$rule('required')"
                  v-model="idNumber"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  label="Número de tarjeta"
                  name="ccnum"
                  filled
                  dense
                  @focus="setCurrentFocus(formFields.cardNumber)"
                  @blur="setCurrentFocus(null)"
                  v-mask="'#### #### #### ####'"
                  autocomplete="cc-number"
                  v-model="numberRaw"
                  :rules="$rule('required')"
                  @input="guessPaymentMethod"
                />
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  label="Fecha de vencimiento"
                  filled
                  dense
                  @focus="setCurrentFocus('cardDate')"
                  @blur="setCurrentFocus(null)"
                  v-model="expireDateRaw"
                  v-mask="'##/##'"
                  :rules="$rule('required')"
                  persistent-hint
                  hint="MM/AA (Ejemplo: 03/25)"
                />
              </v-col>
            </v-row>
            <v-row v-if="issuers">
              <v-col cols="12" sm="6" class="pb-0">
                <v-select
                  label="Banco emisor"
                  return-object
                  filled
                  dense
                  :rules="$rule('required')"
                  item-text="name"
                  :items="issuers"
                  v-model="issuer"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Nombre en la tarjeta"
                  filled
                  dense
                  :rules="$rule('required')"
                  @focus="setCurrentFocus(formFields.cardName)"
                  @blur="setCurrentFocus(null)"
                  v-model="cardData.cardName"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Código de seguridad"
                  @focus="setCurrentFocus(formFields.cardCvv)"
                  @blur="setCurrentFocus(null)"
                  v-mask="'####'"
                  :rules="$rule('required')"
                  filled
                  dense
                  v-model="cardData.cardCvv"
                />
              </v-col>
            </v-row>
            <div class="actions d-flex justify-center">
              <v-btn
                text
                class="mr-2"
                @click="$emit('close')"
                :disabled="loading"
                >Cancelar</v-btn
              >
              <v-btn
                color="primary"
                @click="save"
                :loading="loading"
                :disabled="!formValid"
                >Aceptar</v-btn
              >
            </div>
            <div class="notes text-center mt-4 mb-n2">
              <p class="mb-0 font-size-9e grey--text">
                Sus datos son almacenados de forma segura por
                <v-icon small>mdi-shield</v-icon>
                <span class="font-weight-medium">MercadoPago</span>
              </p>
            </div>
          </v-form @submit.prevent>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import { debounce, importScript } from '../../utils';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';
  import CardWidget from '../widgets/CardWidget.vue';
  import { IUser } from '../../interfaces/IUser';
  import {
    IMercadoPago,
    IMPCardTokenData,
    IMPIDType,
    IMPIssuer,
  } from '../../interfaces/IMercadoPago';
  import PaymentDataService from '../../api/services/paymentData.service';
  import { PaymentDataType } from '../../enums/PaymentDataType';

  @Component({
    components: { CardWidget },
  })
  export default class NewCardModal extends Vue {
    @Prop() user: IUser;
    paymentDataService = new PaymentDataService();
    mp: IMercadoPago = null;
    idTypes: IMPIDType[] = null;
    initialized = false;
    formFields = {
      cardNumber: 'v-card-number',
      cardName: 'v-card-name',
      cardMonth: 'v-card-month',
      cardYear: 'v-card-year',
      cardCvv: 'v-card-cvv',
    };
    cardData = {
      cardName: '',
      cardNumber: '',
      cardNumberNotMask: '',
      cardMonth: '',
      cardYear: '',
      cardCvv: '',
    };
    idType: IMPIDType = null;
    issuers: IMPIssuer[] = null;
    issuer: IMPIssuer = null;
    idNumber = null;
    guessPaymentMethod: () => void = null;
    numberRaw = null;
    expireDateRaw = null;
    loading = false;
    paymentMethod: any = null;
    currentFocus = null;
    formValid = false;

    async created() {
      this.guessPaymentMethod = debounce(() => {
        const cardnumber = this.cardData.cardNumber;
        if (cardnumber.length >= 6) {
          let bin = cardnumber.substring(0, 6);
          this.mp.getPaymentMethod(
            {
              bin: bin,
            },
            this.setPaymentMethod.bind(this)
          );
        }
      }, 500);

      try {
        await this.initMp();
        this.initialized = true;
      } catch (e) {
        vueData.addAlert('Error cargando MercadoPago', AlertType.Error);
        this.$emit('close');
        return;
      }
    }

    async save() {
      this.loading = true;

      try {
        const tokenData = await this.createToken();

        const paymentData = await this.paymentDataService.create({
          type: PaymentDataType.MPCard,
          country: 'AR',
          data: tokenData,
          tz: +this.cardData.cardCvv * 2,
        });

        this.$parent.$emit('created', paymentData);
        this.$emit('close');
      } catch (e) {
        vueData.addAlert(
          'Error guardando la tarjeta, revise los datos e intente nuevamente',
          AlertType.Error
        );
      } finally {
        this.loading = false;
      }
    }

    _clearFocusTimeout = null;
    setCurrentFocus(id: string) {
      if (this._clearFocusTimeout) clearTimeout(this._clearFocusTimeout);

      if (!id) {
        this._clearFocusTimeout = setTimeout(() => {
          this.currentFocus = null;
        }, 50);
      } else {
        this.currentFocus = id;
      }
    }

    createToken() {
      return new Promise((resolve, reject) => {
        try {
          const form = document.createElement('form');

          let input = document.createElement('input');
          input.setAttribute('data-checkout', 'docType');
          input.value = this.idType.id;
          form.appendChild(input);

          input = document.createElement('input');
          input.setAttribute('data-checkout', 'docNumber');
          input.value = this.idNumber;
          form.appendChild(input);

          input = document.createElement('input');
          input.setAttribute('data-checkout', 'email');
          input.value = this.user.email;
          form.appendChild(input);

          input = document.createElement('input');
          input.setAttribute('data-checkout', 'cardholderName');
          input.value = this.cardData.cardName;
          form.appendChild(input);

          input = document.createElement('input');
          input.setAttribute('data-checkout', 'cardExpirationMonth');
          input.value = this.cardData.cardMonth;
          form.appendChild(input);

          input = document.createElement('input');
          input.setAttribute('data-checkout', 'cardExpirationYear');
          input.value = this.cardData.cardYear;
          form.appendChild(input);

          input = document.createElement('input');
          input.setAttribute('data-checkout', 'cardNumber');
          input.value = this.cardData.cardNumber;
          form.appendChild(input);

          input = document.createElement('input');
          input.setAttribute('data-checkout', 'securityCode');
          input.value = this.cardData.cardCvv;
          form.appendChild(input);

          if (this.issuer) {
            input = document.createElement('input');
            input.setAttribute('data-checkout', 'issuer');
            input.value = this.issuer.id;
            form.appendChild(input);
          }

          this.mp.createToken(form, (status, tokenData: IMPCardTokenData) => {
            if (status == 200 || status == 201) {
              resolve(tokenData);
            } else {
              reject(tokenData);
            }
          });
        } catch (e) {
          reject(e);
        }
      });
    }

    @Watch('numberRaw')
    onNumberChanged(newVal) {
      if (!newVal) this.cardData.cardNumber = null;
      else {
        this.cardData.cardNumber = newVal.replaceAll(' ', '');
      }
    }

    @Watch('expireDateRaw')
    onExpireChanged(newVal) {
      if (!newVal) this.cardData.cardMonth = this.cardData.cardYear = null;
      else {
        const parts = newVal.split('/');
        this.cardData.cardMonth = parts[0];
        this.cardData.cardYear = parts[1];
      }
    }

    setPaymentMethod(status, response) {
      if (status == 200) {
        let paymentMethod = response[0];
        //console.log('payment method', paymentMethod.id);
        if (!this.paymentMethod || this.paymentMethod.id !== paymentMethod.id) {
          this.paymentMethod = paymentMethod;
          this.issuers = this.issuer = null;
          if (paymentMethod.additional_info_needed.includes('issuer_id')) {
            this.getIssuers(paymentMethod.id);
          }
        }
      } else {
        console.error(`payment method info error`, response);
      }
    }

    getIssuers(paymentMethodId) {
      this.mp.getIssuers(paymentMethodId, this.setIssuers.bind(this));
    }

    setIssuers(status, issuers: IMPIssuer[]) {
      if (status == 200) {
        this.issuers = issuers;
        this.issuer = issuers[0];
      } else {
        console.error(`issuers method info error`, issuers);
        vueData.addAlert(
          'Ocurrió un error, intente nuevamente en un momento',
          AlertType.Error
        );
        this.$emit('close');
      }
    }

    private async initMp() {
      if (!window['Mercadopago'])
        await importScript(
          'https://secure.mlstatic.com/sdk/javascript/v1/mercadopago.js'
        );

      this.mp = window['Mercadopago'];

      if (!this.mp) throw new Error();

      this.mp.setPublishableKey('APP_USR-0c5e12e5-9e51-4b5a-bf94-7f763a4ace05');

      await new Promise((resolve, reject) => {
        this.mp.getIdentificationTypes((status, types) => {
          if (status !== 200) reject();

          this.idTypes = types;
          this.idType = types[0];
          resolve();
        });
      });

      this.mp = window['Mercadopago'];
    }
  }
</script>
